let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hl2oi")).then(() => parcelRequire('kLgX2'));